module.exports = __webpack_public_path__ + "static/media/Leave.b3463719.svg";